import { useMemo } from "react";

import { Roles } from "src/core/constants/roles";
import { useUser } from "src/core/contexts/UserContext";

export const usePermissions = () => {
  const { userGroups } = useUser();

  const { hasRole, hasAllRoles, hasAnyRole } = useMemo(() => {
    const set = new Set<Roles>(userGroups);

    const hasRole = (role: Roles) => set.has(role);
    // Astuce: passer set.has avec thisArg évite d’allouer une lambda par élément
    const hasAllRoles = (roles: Roles[]) => roles.every(set.has, set);
    const hasAnyRole = (roles: Roles[]) => roles.some(set.has, set);

    return { hasRole, hasAllRoles, hasAnyRole };
  }, [userGroups]);

  return { hasRole, hasAllRoles, hasAnyRole };
};
